/** Modal horizontal gutter (px); keep header, body, footer aligned (Add / Edit user modals). */
export const MODAL_PAD_X = 28;
/** Modal vertical section padding (px). */
export const MODAL_PAD_Y = 24;
